import React from 'react';
// @ts-ignore
import {BrowserRouter as Router, HashRouter, Route, Switch} from 'react-router-dom';
import {Provider} from "react-redux";
import store from "./redux/store";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/Woodchipping/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";
import HomePage from "./pages/Woodchipping/HomePage";
import NewLogChippingPage from "./pages/Woodchipping/NewLogChippingPage";
import HomeDetailLogsPage from "./pages/Woodchipping/HomeDetailLogsPage";
import HomeDetailLogEditPage from "./pages/Woodchipping/HomeDetailLogEditPage";
import NewLogSalePage from "./pages/Woodchipping/NewLogSalePage";
import NewLogChippingCsvPage from "./pages/Woodchipping/NewLogChippingCsvPage"
import ModulePage from "./pages/ModulePage";
import SrcLoginPage from "./pages/Services/SrcLoginPage";
import SrcSwitchCompanyPage from "./pages/Services/SrcSwitchCompanyPage";

function App() {
    return (
        <Provider store={store}>
        <Router>
            <Switch>
                <Route exact path="/login" component={LoginPage}/>
                <Route exact path="/src-login" component={SrcLoginPage}/>
                <Route exact path="/src-switch-company" component={SrcSwitchCompanyPage} />

                <Route exact path="/home" component={HomePage}/>
                <Route exact path="/home-detail-logs" component={HomeDetailLogsPage}/>
                <Route exact path="/home-detail-log-edit" component={HomeDetailLogEditPage}/>
                <Route exact path="/new-log-chipping" component={NewLogChippingPage}/>
                <Route exact path="/new-log-chipping-csv" component={NewLogChippingCsvPage}/>

                <Route exact path="/modules" component={ModulePage}/>

                <Route exact path="/new-log-sale" component={NewLogSalePage}/>
                <Route exact path="/" component={LandingPage}/>
                <Route exact path="*" component={NotFoundPage}/>

            </Switch>
        </Router>
        </Provider>
    );
}

export default App;
